<template>
    <CmsBlock
        v-for="(block, key) in data"
        :key="key"
        :data="block"
        :has-eager-image="key === 0"
        :product="product"
        :related-products="relatedProducts"
        :page-type="pageType"
    />
</template>

<script lang="ts" setup>
import { computed, provide } from 'vue'
import type {
    BlockAnchorFragment,
    BlockFragment,
    ShopWithConfidenceProductFragment,
} from '@/graphql/api'
import { isNotUndefinedOrNull } from '@/helpers'

import CmsBlock from '@/components/cms/CmsBlock.vue'
import type { Props as RelatedProductProps } from '@/components/rings/RelatedProducts.vue'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

interface Props {
    data?: BlockFragment[]
    relatedProducts?: RelatedProductProps
    product?: ShopWithConfidenceProductFragment
    pageType: PageType
}

const props = withDefaults(defineProps<Props>(), {
    data: () => [],
    relatedProducts: undefined,
    product: undefined,
})

const anchors = computed((): BlockAnchorFragment[] =>
    props.data.map((block) => block.anchor).filter(isNotUndefinedOrNull)
)

provide('cms.anchors', anchors)
</script>
